export const styles = {
  //table
  tableContainer: "relative overflow-x-auto shadow-md sm:rounded-lg",
  table: "w-full text-sm text-left text-zinc-500",
  tHead:
    "text-xs text-white uppercase bg-indigo-500",
  th: "px-6 py-4 font-medium text-gray-900 md:break-all",
};
